var _ellipse, _path;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgRwAiIcon = function SvgRwAiIcon(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 11,
    viewBox: "0 0 12 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 6,
    cy: 5.5,
    rx: 6,
    ry: 5.5,
    fill: "#0675DD",
    fillOpacity: 0.4
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.06036 5.55983C4.50258 5.80047 5.63958 6.74788 5.9282 7.9497C5.94398 8.01677 6.05523 8.01677 6.0718 7.9497C6.36056 6.74785 7.49746 5.80035 8.93964 5.55983C9.02012 5.54668 9.02012 5.45398 8.93964 5.44017C7.49742 5.19953 6.36042 4.25212 6.0718 3.0503C6.05602 2.98323 5.94477 2.98323 5.9282 3.0503C5.63944 4.25215 4.50254 5.19965 3.06036 5.44017C2.97988 5.45332 2.97988 5.54602 3.06036 5.55983Z",
    fill: "#E6F3FF"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgRwAiIcon);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "rw-ai-icon.ebdb0771cdcc5410b0bc2594bd471e9c.svg";